import { Outlet, useLocation } from "react-router-dom";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";

const Layout = () => {
    const location = useLocation();
    const noHeaderFooter = location.pathname === '/signin' || location.pathname === '/signup';

    return (
        <div className="app">
            {!noHeaderFooter && <Header />}
            <Outlet />
            {!noHeaderFooter && <Footer />}
        </div>
    );
};

export default Layout;
